import React from 'react';
import { SimpleGrid } from '../../../../../tailwindComponents/grid/SimpleGrid';
import { HeaderText2TW } from '../../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { BodyTextTW } from '../../../../../tailwindComponents/bodyText/BodyTextTW';

export const DeleteSuccessMessage: React.FC = () => {
  return (
    <SimpleGrid className={'text-center'}>
      <HeaderText2TW>Successfully deleted!</HeaderText2TW>
      <BodyTextTW>The document was deleted successfully.</BodyTextTW>
    </SimpleGrid>
  );
};
